import type { Article } from "@/src/constants/articles";

export function ArticleHero({ article }: { article: Article }) {
    return (
        <div className="pt-40">
            <div className="max-w-3xl mx-auto px-6 pb-12">
                <p className="uppercase tracking-[0.3em] text-xs text-stone-400 mb-6 font-light">
                    {article.category} — {article.date}
                </p>
                <h1 className="font-serif text-4xl md:text-6xl font-light italic leading-tight mb-8">
                    {article.title}
                </h1>
                <div className="flex items-center gap-4 text-sm text-stone-400 font-light">
                    <span>{article.author}</span>
                    <span className="w-1 h-1 rounded-full bg-stone-300" />
                    <span>{article.readTime}</span>
                </div>
            </div>
            <div className="w-full aspect-[21/9] overflow-hidden">
                <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover"
                    referrerPolicy="no-referrer"
                />
            </div>
        </div>
    );
}
